import { createContext } from "react";

export const XadrezContext = createContext();